/**
 * Search API client — typed functions for the global search endpoint.
 */
import { apiClient } from './index';

export type SearchResultType = 'task' | 'record' | 'project';

export interface SearchResult {
  type: SearchResultType;
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  color: string;
  route: string; // frontend route, e.g. /tasks/<id>
}

export interface SearchResponse {
  data: SearchResult[];
  query: string;
  total: number;
}

export async function search(
  q: string,
  types?: SearchResultType[],
  limit = 20,
): Promise<SearchResponse> {
  const params: Record<string, string> = { q, limit: String(limit) };
  if (types && types.length > 0) params.types = types.join(',');
  const { data } = await apiClient.get<SearchResponse>('/search', { params });
  return data;
}
